document.addEventListener("turbolinks:load", function() {

  $('#applySchedule').click(function (event){
    event.preventDefault();

    num_guests = $('#num_reservations').val()
    timeslot = $('#timeslot_schedule_select').val()
    day = $('#day_schedule_select').val()

    if (num_guests < 0) {
      alert("You must choose a value of zero or greater.")
      num_guests = $('#num_reservations').val(0)
      return false
    }

    if (timeslot == "all" && day == -1) {
      $('.num-guests').val(num_guests);
    } else if (timeslot == "all") {
      $('.num-guests' + '.' + day).val(num_guests);
    } else if (day == -1) {
      $('.num-guests' + '.' + timeslot).val(num_guests);
    } else {
      $('.num-guests' + '.' + timeslot + '.' + day).val(num_guests);
    }

  });
});
